import QuillEditorContainer from "../../../../Components/Miscellaneous/Editor/QuillEditor/QuillEditorContainer";

const QuillEditor = () => {
  return <QuillEditorContainer />;
};

export default QuillEditor;
